import { ActionIcon, Button, Checkbox, Select, Table, TextInput } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";

import { useT } from "../i18n/script";
import { FIELD_TYPES, type FieldDef } from "./DynamicFields";

/** Uređivač definicija polja (fenološke faze, šifarnici, proširenja). */
export function FieldsEditor({ fields, onChange, locked = [] }: { fields: FieldDef[]; onChange: (f: FieldDef[]) => void; locked?: string[] }) {
  const { t } = useT();
  const set = (i: number, patch: Partial<FieldDef>) => onChange(fields.map((f, j) => (i === j ? { ...f, ...patch } : f)));
  return (
    <>
      <Table fz="xs" verticalSpacing={2}>
        <Table.Thead><Table.Tr><Table.Th>{t("Ključ")}</Table.Th><Table.Th>{t("Naziv")}</Table.Th><Table.Th>{t("Tip")}</Table.Th>
          <Table.Th>{t("Opcije")}</Table.Th><Table.Th>{t("Jed.")}</Table.Th><Table.Th>{t("Obav.")}</Table.Th><Table.Th /></Table.Tr></Table.Thead>
        <Table.Tbody>
          {fields.map((f, i) => {
            const lock = locked.includes(f.key);
            return (
              <Table.Tr key={i}>
                <Table.Td><TextInput size="xs" disabled={lock} value={f.key} onChange={(e) => set(i, { key: e.currentTarget.value.toLowerCase().replace(/[^a-z0-9_]/g, "_") })} /></Table.Td>
                <Table.Td><TextInput size="xs" value={f.label} onChange={(e) => set(i, { label: e.currentTarget.value })} /></Table.Td>
                <Table.Td><Select size="xs" w={130} data={FIELD_TYPES} value={f.type} onChange={(v) => set(i, { type: (v ?? "text") as FieldDef["type"] })} /></Table.Td>
                <Table.Td><TextInput size="xs" disabled={!["select", "multiselect"].includes(f.type)} value={(f.options ?? []).join(", ")}
                  onChange={(e) => set(i, { options: e.currentTarget.value.split(",").map((s) => s.trim()).filter(Boolean) })} /></Table.Td>
                <Table.Td><TextInput size="xs" w={60} value={f.unit ?? ""} onChange={(e) => set(i, { unit: e.currentTarget.value || undefined })} /></Table.Td>
                <Table.Td><Checkbox size="xs" checked={!!f.required} onChange={(e) => set(i, { required: e.currentTarget.checked })} /></Table.Td>
                <Table.Td><ActionIcon size="sm" color="red" variant="subtle" disabled={lock} onClick={() => onChange(fields.filter((_, j) => j !== i))}><IconTrash size={12} /></ActionIcon></Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
      <Button size="compact-xs" variant="light" leftSection={<IconPlus size={12} />} mt={4}
        onClick={() => onChange([...fields, { key: `polje_${fields.length + 1}`, label: "", type: "text" }])}>{t("Dodaj polje")}</Button>
    </>
  );
}
